import React, { useEffect, useState } from "react";
import { Button, Col, Table } from "reactstrap";
import NoteModalBody from "./NoteModalBody";
import NoteListData from "./NoteListData";
import NoteModalButton from "./NoteModalButton";

import { ADD } from "./NoteConstants";
import ChildrenModal from "../../components/modals/ChildrenModal";
import dayjs from "dayjs";
/**
 * Render this component with the props in order to use the
 * functionality of all the note components. Data is saved on the
 * notes prop field passed in and can be saved to the database by
 * simply saving the respective store object to the database.
 *
 * Component makes use of React.Children and React Component Composition.
 * @see https://reactjs.org/docs/composition-vs-inheritance.html
 *
 * @param {Array} notes - Store Notes array containing objects with
 * information about each note.
 * @param {React.SetStateAction} editNotes - Setter function for the
 * Store notes field.
 * @param {boolean} disableAddAndSave - Disables the adding and saving
 * of notes
 * @param {Function} saveNotes - Calls save api to save the object with
 * the updated notes.
 */
const NoteButton = ({ notes, editNotes, disableAddAndSave, saveNotes }) => {
	//console.log(unescapeNoteDescription(normalizeNoteData(notes)));
	// Local states
	const [xNotes, setXNotes] = useState("");
	const [lNote, setLNote] = useState("");
	const [addText, setAddText] = useState(ADD);
	const [index, setIndex] = useState(notes?.length);
	const [openModal, setOpenModal] = useState(false);
	const [openForm, setOpenForm] = useState(false);

	// Set local states to initial values
	const clearFields = () => {
		setLNote("");
		setIndex(notes.length);
	};

	// useEffect(() => {
	// 	const xnotes = notes.slice().sort((a, b) => {
	// 		const parse = (str) => dayjs(str, "MMM D, YYYY [at] h:mm:ss a").toDate();
	// 		return parse(b.createdOn) - parse(a.createdOn);
	// 	});
	// 	console.log(notes);
	// 	console.log(xnotes);
	// 	setXNotes(xnotes);
	// }, []);
	useEffect(() => {
		const xnotes = notes.slice().sort((a, b) => {
			const parse = (str) => dayjs(str, "MMM D, YYYY [at] h:mm:ss a").toDate();
			return parse(b.createdOn) - parse(a.createdOn);
		});
		console.log(notes);
		console.log(xnotes);
		setXNotes(xnotes);

		//editNotes(unescapeNoteDescription(notes));
		setIndex(notes.length);
	}, [notes]);
	// useEffect(() => {
	// 	// console.log("Notes before normalization:");
	// 	// console.log(notes);
	// 	// console.log(unescapeNoteDescription(normalizeNoteData(notes)));
	// 	//editNotes(unescapeNoteDescription(normalizeNoteData(notes)));
	// }, []);

	// Function to open the modal
	const toggle = () => setOpenModal(!openModal);

	const toggleForm = () => setOpenForm(!openForm);

	return (
		<>
			{openModal && (
				<NoteModal modal={openModal} toggle={toggle}>
					<ChildrenModal
						size="lg"
						modal={openForm}
						toggle={toggleForm}
						modalTitle="Notes"
						onClosed={clearFields}
						children={
							<>
								<NoteModalBody lNote={lNote} setLNote={setLNote} />
								<NoteModalButton
									index={index}
									lNote={lNote}
									notes={notes}
									buttonText={addText}
									editNotes={editNotes}
									setButtonText={setAddText}
									clearFields={clearFields}
									disableButtons={disableAddAndSave}
									saveNotes={saveNotes}
									toggle={toggleForm}
								/>
							</>
						}
					/>
					<Col className="mb-2">
						<Button onClick={toggleForm}>Add New</Button>
					</Col>
					<Col>
						<div style={{ overflowX: "auto" }}>
							{notes.length > 0 && (
								<Table striped hover>
									<thead>
										<tr className="align-top">
											<th style={{ width: "50px" }}>#</th>
											<th style={{ width: "150px" }}>Created By</th>
											<th style={{ width: "200px" }}>Created On</th>
											<th style={{ width: "150px" }}>Modified By</th>
											<th style={{ width: "200px" }}>Modified On</th>
											<th>Description</th>
											<th>Actions</th>
										</tr>
									</thead>
									<tbody>
										<NoteListData
											notes={xNotes}
											editNotes={editNotes}
											setLNote={setLNote}
											setIndex={setIndex}
											setButtonText={setAddText}
											clearFields={clearFields}
											disableButtons={disableAddAndSave}
											saveNotes={saveNotes}
											toggle={toggleForm}
										/>
									</tbody>
								</Table>
							)}
						</div>
					</Col>
				</NoteModal>
			)}
			<div className="btn btn-primary btn-md" onClick={toggle}>
				<i className="nc-icon nc-bullet-list-67"></i> Notes
			</div>
		</>
	);
};

export default NoteButton;

/**
 *	Renders the whole modal
 *
 * @param {boolean} modal - Local state for handling modal open/close
 * @callback toggle - Sets the modal state to !{@param modal}
 * @param {React.Children} - Children component to render in modal body
 * */
const NoteModal = ({ modal, toggle, children }) => {
	return (
		<ChildrenModal
			toggle={toggle}
			modal={modal}
			children={children}
			modalTitle="Notes"
		/>
	);
};
function normalizeNoteData(rawInput) {
	const result = [];

	try {
		// Find where the character array ends and real objects start
		const charPart = [];
		const jsonPart = [];

		for (const item of rawInput) {
			if (
				typeof item === "string" &&
				item.length === 1 &&
				(charPart.length === 0 || item !== "[")
			) {
				charPart.push(item);
			} else if (typeof item === "object") {
				jsonPart.push(item); // already valid
			}
		}

		// Join character array and parse once
		const joined = charPart.join("");
		const parsedFromCharArray = JSON.parse(joined);

		if (Array.isArray(parsedFromCharArray)) {
			result.push(...parsedFromCharArray);
		}
		result.push(...jsonPart);
	} catch (e) {
		console.error("Note recovery failed:", e);
	}

	return result;
}
function unescapeNoteDescription(notes) {
	return notes.map((note) => {
		if (typeof note.description === "string") {
			return {
				...note,
				description: note.description
					.replace(/\r\n/g, "\n") // real carriage return + newline
					.replace(/\r/g, "\n") // solo carriage return
					.replace(/\n\n+/g, "\n\n"), // compress double newlines
			};
		}
		return note;
	});
}
